module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-person-fill-ab527c66.svg";